import { LookbookContextProvider } from '@app/components/lookbook/context/LookbookContext';
import { LookbookDetailsModalContextProvider } from '@app/components/lookbook/context/LookbookDetailsModalContext';
import { ReadonlyLookbookProductCard } from '@app/components/products/LookbookProductsList/LookbookProductCard';
import { ProductCardSkeleton } from '@app/components/products/ProductCard/ProductCardSkeleton';
import { LookbookProductDetailsModal } from '@app/components/products/ProductDetails/LookbookProductDetailsModal';
import { SkeletonLayout } from '@app/components/various/SkeletonLayout';
import { useLookbookWishlistProducts } from '@app/services/hooks/lookbook/useLookbookWishlistProducts';
import { useTranslation } from 'react-i18next';

interface Props {
  lookbookId: string;
  wishlistId: string;
  productId: string | undefined;
  variantId: string | undefined;
}

export const AccountRequestWishlist = ({ lookbookId, productId, variantId, wishlistId }: Props) => {
  const { t } = useTranslation(['lookbook', 'selections']);
  const { products, isLoading } = useLookbookWishlistProducts({ lookbookId, wishlistId });

  return (
    <LookbookContextProvider lookbookId={lookbookId}>
      <div className="flex items-center justify-between pt-8">
        <h3 className="flex items-center gap-1 heading-3">
          <span>{t('lookbook:wishlist')}</span>
          {!isLoading && <span className="text-neutral-40">({products.length})</span>}
        </h3>
      </div>
      <div className="mr-0 grid grid-cols-[repeat(auto-fill,minmax(10.5rem,1fr))] gap-x-3 gap-y-3 pb-8 pt-5 md:grid-cols-[repeat(auto-fill,minmax(13.5rem,1fr))]">
        <SkeletonLayout skeleton={<ProductCardSkeleton />} repeatLayout={4} isLoading={isLoading}>
          {products.map(product => (
            <ReadonlyLookbookProductCard key={product.product} gridSize="medium" productInfo={product} />
          ))}
        </SkeletonLayout>
      </div>
      <LookbookDetailsModalContextProvider
        lookbookId={lookbookId}
        productId={productId}
        variantId={variantId}
        products={products}
        isReadOnly
      >
        <LookbookProductDetailsModal />
      </LookbookDetailsModalContextProvider>
    </LookbookContextProvider>
  );
};
